import { defineStore } from 'pinia'

export const useNavigationStore = defineStore('navigation', () => {
  const lastOrganizationURLPath = ref('')
  const lastWorkspaceURLPath = ref('')

  const setLastOrganizationURLPath = (path: string) => {
    lastOrganizationURLPath.value = path
  }
  const setLastWorkspaceURLPath = (path: string) => {
    lastWorkspaceURLPath.value = path
  }

  const $reset = () => {
    lastOrganizationURLPath.value = ''
    lastWorkspaceURLPath.value = ''
  }

  return {
    lastOrganizationURLPath,
    lastWorkspaceURLPath,
    setLastOrganizationURLPath,
    setLastWorkspaceURLPath,
    $reset,
  }
})
